export { default } from "./LinkApp";
